<div class="login-page">
  <div class="loginForm">
    <div style="text-align: center; margin-top: 10%; transform: scale(0.85)">
      <img class="lesteLogo" [src]="imageUrl">
    </div>
    <div class="forma1">
      <div class="loginLabel">
        @if (fromEmail) {
          <h2 class="loginLabel">{{ labels.lblEnterNewPassword }}</h2>
        }
        @if (!fromEmail) {
          <h2 class="loginLabel">{{ labels.lblForgotPassEmail }}</h2>
        }
      </div>
      <form action="" #forgotPassForm="ngForm" style="margin-top: 7%;" (ngSubmit)="onSubmit(forgotPassForm)">
        @if (fromEmail) {
          <div>
            <mat-form-field class="no-line inputFieldForm" appearance="none">
              <span class = "inputIcon" style = "display: inline-block">
                <img src = "./assets/icons/passwordLoginIcon.png" alt = "password login icon">
              </span>
              <span style="display: inline-block; vertical-align: middle; padding-left: 10px;">
                <input
                  minlength="6"
                  [type]="isActive ? 'password' : 'text'"
                  matInput
                  required
                  name="password"
                  placeholder = {{labels.lblPassword}}
                  ngModel
                  #password="ngModel">
              </span>
              @if (isActive) {
                <span class="inputIcon" style="float: right; margin-right: 11px; cursor: pointer;">
                  <img (click)="changeActive()" src="./assets/icons/hidePasswordIcon.png" alt="password icon hide">
                </span>
              }
              @if (!isActive) {
                <span class="inputIcon" style="float: right; margin-right: 11px; cursor: pointer;">
                  <img (click)="changeActive()" src="./assets/icons/showPasswordIcon.png" alt="password icon show">
                </span>
              }
            </mat-form-field>
            <mat-form-field class="no-line inputFieldForm" appearance="none">
              <span class = "inputIcon" style = "display: inline-block">
                <img src = "./assets/icons/passwordLoginIcon.png" alt = "password login icon">
              </span>
              <span style="display: inline-block; vertical-align: middle; padding-left: 10px;">
                <input
                  minlength="6"
                  [type]="isActive ? 'password' : 'text'"
                  matInput
                  required
                  [class.redBorder] = 'wrongConfirmedPassword'
                  placeholder = {{labels.lblConfirmPassword}}
                  name="confirmPassword"
                  ngModel
                  #confirmPassword="ngModel">
              </span>
              @if (isActive) {
                <span class="inputIcon" style="float: right; margin-right: 11px; cursor: pointer;">
                  <img (click)="changeActive()" src="./assets/icons/hidePasswordIcon.png" alt="password icon hide">
                </span>
              }
              @if (!isActive) {
                <span class="inputIcon" style="float: right; margin-right: 11px; cursor: pointer;">
                  <img (click)="changeActive()" src="./assets/icons/showPasswordIcon.png" alt="password icon show">
                </span>
              }
            </mat-form-field>
            @if (wrongConfirmedPassword) {
              <p style="color: red">{{labels.lblPasswordFieldError}}</p>
            }
            <br>
              <button class="login-button">
                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-9" style="text-align: center; margin: auto;">
                    <h3 class="loginBtnLabel">{{ labels.lblChangePassword }}</h3>
                  </div>
                  <div class="col-1"><img style="float: right; padding-right: 15px;"
                    src='https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/loginIcon.png?alt=media&token=331da5b1-d77f-4c81-89a1-0e35b3feea30'>
                  </div>
                </div>
              </button>
            </div>
          }
          @if (!fromEmail) {
            <div>
              <mat-form-field class="no-line inputFieldForm" appearance="none">
                <span class="inputIcon" style="display: inline-block">
                  <img
                    src="https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/emailLoginIcon.png?alt=media&token=0999ab04-a16b-44ca-b745-326eb4edcd23"
                    alt="email login icon">
                </span>
                <span style="display: inline-block; vertical-align: middle; padding-left: 10px;">
                  <input
                    matInput
                    placeholder="abc@email.com"
                    required
                    name="email"
                    ngModel
                    #email="ngModel">
                </span>
              </mat-form-field>
              <br>
                <button class="login-button">
                  <div class="row">
                    <div class="col-1"></div>
                    <div class="col-9" style="text-align: center; margin: auto;">
                      <h3 class="loginBtnLabel">{{ labels.lblRequestAReset }}</h3>
                    </div>
                    <div class="col-1"><img style="float: right; padding-right: 15px;"
                      src='https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/loginIcon.png?alt=media&token=331da5b1-d77f-4c81-89a1-0e35b3feea30'>
                    </div>
                  </div>
                </button>
              </div>
            }

          </form>

          <div class="row">
        <div class="col-11" style="font-style: normal;
        font-weight: normal;
        font-size: 16px; text-align: center; margin: auto; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; cursor: pointer"
              (click)="backToLogin()">
              {{ labels.lblBackToLogin }}
            </div>
          </div>
        </div>
      </div>
    </div>
